export default {
    namespaced: true,
    state: {
        leadFilters: localStorage.getItem('leadFilters') ? JSON.parse(localStorage.getItem('leadFilters')) : {
            type: null,
            agent: [],
            status: [],
            source: 1,
            state: []
        },
        followUpFilters: localStorage.getItem('followUpFilters') ? JSON.parse(localStorage.getItem('followUpFilters')) : {
            status: [],
            lead: [],
            user: [],
            dateTime: []
        }
    },
    mutations: {
        SET_TYPE_FILTER(state, type) {
            state.leadFilters.type = type;
        },
        SET_STATE_FILTER(state, states) {
            state.leadFilters.state = [];

            states.forEach(s => {
                state.leadFilters.state.push(s);
            });
            localStorage.setItem('leadFilters', JSON.stringify(state.leadFilters));
        },
        SET_STATUS_FILTER(state, statuses) {
            state.leadFilters.status = [];

            statuses.forEach(s => {
                state.leadFilters.status.push(s);
            });
            localStorage.setItem('leadFilters', JSON.stringify(state.leadFilters));
        },
        SET_AGENT_FILTER(state, agents) {
            state.leadFilters.agent = [];

            agents.forEach(a => {
                state.leadFilters.agent.push(a);
            });
            localStorage.setItem('leadFilters', JSON.stringify(state.leadFilters));
        },
        SET_SOURCE_FILTER(state, source) {
            state.leadFilters.source = source;
            localStorage.setItem('leadFilters', JSON.stringify(state.leadFilters));
        },
        SET_FOLLOWUP_STATUS_FILTER(state, statuses) {
            state.followUpFilters.status = [];

            statuses.forEach(s => {
                state.followUpFilters.status.push(s);
            });
            localStorage.setItem('followUpFilters', JSON.stringify(state.followUpFilters));
        },
        SET_FOLLOWUP_LEAD_FILTER(state, lead) {
            state.followUpFilters.lead = [];

            lead.forEach(l => {
                state.followUpFilters.lead.push(l);
            });
            localStorage.setItem('followUpFilters', JSON.stringify(state.followUpFilters));
        },
        SET_FOLLOWUP_USER_FILTER(state, user) {
            state.followUpFilters.user = [];

            user.forEach(u => {
                state.followUpFilters.user.push(u);
            });
            localStorage.setItem('followUpFilters', JSON.stringify(state.followUpFilters));
        },
        SET_FOLLOWUP_DATETIME_FILTER(state, dateTimes) {
            state.followUpFilters.dateTime = [];

            dateTimes.forEach(d => {
                state.followUpFilters.dateTime.push(d);
            });
            localStorage.setItem('followUpFilters', JSON.stringify(state.followUpFilters));
        },
    },
    getters: {
        leadFilters: (state) => state.leadFilters,
        followUpFilters: (state) => state.followUpFilters,
    }
}